import api from './api';

interface EstoqueData {
  empresa_id: number;
  produto_id: number;
  estoque_minimo?: number;
  estoque_atual?: number;
}

const newEstoque = async ({
  empresa_id,
  produto_id,
  estoque_minimo,
  estoque_atual,
}: EstoqueData): Promise<void> => {
  await api.post('/estoque', {
    empresa_id,
    produto_id,
    estoque_minimo,
    estoque_atual,
    ativo: true,
  });
};

export default newEstoque;
